'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, styled, useColorScheme } from '@mui/material';
import Image, { type StaticImageData } from 'next/image';
import { forwardRef, type ComponentProps } from 'react';
import { ApplicationsLogos } from '@/assets/logos/applications';
const _CircleImage = forwardRef<HTMLSpanElement, {
  alt: string;
  src: StaticImageData;
  srcDark?: StaticImageData;
  contrast?: boolean;
} & ComponentProps<typeof Box>>((t0, ref) => {
  const $ = _c(13);
  let alt;
  let props;
  let src;
  let srcDark;
  if ($[0] !== t0) {
    const {
      alt: t1,
      src: t2,
      srcDark: t3,
      contrast,
      ...t4
    } = t0;
    alt = t1;
    src = t2;
    srcDark = t3;
    props = t4;
    $[0] = t0;
    $[1] = alt;
    $[2] = props;
    $[3] = src;
    $[4] = srcDark;
  } else {
    alt = $[1];
    props = $[2];
    src = $[3];
    srcDark = $[4];
  }
  const {
    mode
  } = useColorScheme();
  const resolvedSrc = mode === "dark" && srcDark ? srcDark : src;
  const t1 = resolvedSrc || ApplicationsLogos.Unknown;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "24px",
      height: "24px"
    };
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== alt || $[7] !== t1) {
    t3 = <Image alt={alt} src={t1} width={24} height={24} style={t2} />;
    $[6] = alt;
    $[7] = t1;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== props || $[10] !== ref || $[11] !== t3) {
    t4 = <Box component="span" ref={ref} {...props}>{t3}</Box>;
    $[9] = props;
    $[10] = ref;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
});
export const CircleImage = styled(_CircleImage)(props => ({
  width: '24px',
  height: '24px',
  minHeight: '24px',
  minWidth: '24px',
  backgroundColor: props.contrast ? 'var(--mui-palette-background-default)' : 'transparent',
  ...props.theme.applyStyles('dark', {
    backgroundColor: !props.contrast ? 'var(--mui-palette-background-default)' : 'transparent'
  }),
  display: 'inline-flex',
  borderRadius: '50%',
  marginRight: '8px',
  ':last-of-type': {
    marginRight: 0
  }
}));